/**
 * Footer revision bar. Same data as the old StagesTab footer plus the
 * phone-safety honesty line: the backend accepts stage_index 0–63 on
 * gates, but the phone evaluator has no per-stage tracking yet — only
 * stage_index==0 gates are emitted to phones via geofence_set.
 */

import React from 'react';

import { EventRow } from '@/services/fleet';

export const RevisionBar: React.FC<{ event: EventRow }> = ({ event }) => (
  <div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-1 rounded border border-border bg-bg-input px-3.5 py-2.5 text-xs text-fg-secondary">
    <span>
      Geofence revision:{' '}
      <span className="font-mono text-fg">{event.geofence_revision}</span>
    </span>
    <span>
      Armed phones:{' '}
      <span className="font-mono text-status-online">{event.enrollment_counts.armed}</span>
      {' · '}save re-emits <span className="font-mono">geofence_set</span> — phones arm on
      SS1 (stage 0) gates + every stage&apos;s start time/timeout; start-list saves
      resolve each car&apos;s own minute into its device&apos;s payload
    </span>
  </div>
);

export default RevisionBar;
